import { bomActionTypes } from '../actions/bomActions';

const BOMReducers = (state = { }, action) => {
  switch (action.type) {
  case bomActionTypes.GET_BOM.LOADING: {
    const { getBOMLoading } = action;
    return {
      ...state,
      getBOMLoading,
    };
  }
  case bomActionTypes.GET_BOM.SUCCESS: {
    const { billOfMaterials } = action;
    return {
      ...state,
      billOfMaterials,
    };
  }
  case bomActionTypes.GET_BOM_BY_ID.LOADING: {
    const { getBOMByIdLoading } = action;
    return {
      ...state,
      getBOMByIdLoading,
    };
  }
  case bomActionTypes.GET_BOM_BY_ID.SUCCESS: {
    const { selectedBOM } = action;
    return {
      ...state,
      selectedBOM,
    };
  }
  case bomActionTypes.CREATE_BOM.LOADING: {
    const { createBOMLoading } = action;
    return {
      ...state,
      createBOMLoading,
    };
  }
  case bomActionTypes.UPDATE_BOM.LOADING: {
    const { updateBOMLoading } = action;
    return {
      ...state,
      updateBOMLoading,
    };
  }
  case bomActionTypes.UPDATE_STATUS_BOM.LOADING: {
    const { updateBOMStatusLoading } = action;
    return {
      ...state,
      updateBOMStatusLoading,
    };
  }
  case bomActionTypes.DELETE_BOM.LOADING: {
    const { deleteBOMLoading } = action;
    return {
      ...state,
      deleteBOMLoading,
    };
  }
  case bomActionTypes.UPDATE_BOM_WORKFLOW_STEP.LOADING: {
    const { updateBOMWorkflowStepLoading } = action;
    return {
      ...state,
      updateBOMWorkflowStepLoading,
    };
  }
  case bomActionTypes.ACTIVATE_BOM.LOADING: {
    const { activateBOMLoading } = action;
    return {
      ...state,
      activateBOMLoading,
    };
  }
  // Bulk upload BOM
  case bomActionTypes.BULK_UPLOAD_BOM.LOADING: {
    const { bulkUploadBOMLoading } = action;
    return {
      ...state,
      bulkUploadBOMLoading,
    };
  }

  case bomActionTypes.BULK_UPLOAD_BOM.SUCCESS: {
    const { bulkUploadBOMResults } = action;
    return {
      ...state,
      bulkUploadBOMResults,
    };
  }

  case bomActionTypes.GET_BOM_JW.LOADING: {
    const { getBomJobWorkLoading } = action;
    return {
      ...state,
      getBomJobWorkLoading,
    }
  }
  
  case bomActionTypes.GET_BOM_JW.SUCCESS: {
    const { bomJobWorks } = action;
    return {
      ...state,
      bomJobWorks,
    }
  }

  case bomActionTypes.UPDATE_BOM_JW.LOADING: {
    const { updateBomJobworkLoading } = action;
    return {
      ...state,
      updateBomJobworkLoading,
    }
  }

  default: {
    return state;
  }
  }
};

export default BOMReducers;
